import { Communication } from '@medplum/fhirtypes';
import { BARIENDO_CT_SYSTEM, CommunicationCategory } from '@bariendo/lib/constants';
import { PacIntroCallAnswers, parseCiIntroCallAnswers, pickSavedCallNote } from '@bariendo/lib/patient-access-note';

/**
 * The consultation-stage call note. One category carries both the PAC intro
 * call and the PN consultation (Intake 1.1), told apart by the note's visit type.
 */
export const CONSULTATION_NOTE_CATEGORY_TOKEN = `${BARIENDO_CT_SYSTEM}|${CommunicationCategory.PAC_INTRO_CALL_NOTE}`;

export interface SavedCallNote {
  /** The answers themselves — Package and Location fall back to `procedure` / `loc`. */
  answers: PacIntroCallAnswers;
}

/**
 * Re-exported from `@bariendo/lib` rather than defined here: the
 * send-sms-message bot resolves a patient's recorded market from the same
 * saved note this panel displays, and the two must not be able to disagree.
 */
export { pickSavedCallNote };

/** The saved note's answers, from either script: both record `procedure` and `loc` under the same ids. */
export function readSavedCallNote(notes: Communication[]): SavedCallNote | undefined {
  const note = pickSavedCallNote(notes);
  if (!note) return undefined;

  return { answers: parseCiIntroCallAnswers(note) };
}
